import Image from "next/legacy/image";
import { blurDataURL } from "../../../utils/constants/images";
import { DividerH } from "../../common/RedDividerH";

const TrophyDataCard = ({ trophy }) => {
  const {
    name: trophyName,
    number_of_times_won: numberOfTimesWon,
    image: trophyImage,
  } = trophy;
  return (
    <>
      <div className="w-full min-h-80 bg-black aspect-w-1 aspect-h-1 rounded-md overflow-hidden group-hover:opacity-75 lg:h-80 xl:aspect-w-7 xl:aspect-h-8 transform transition duration-500 hover:scale-105">
        <div className="w-full h-full object-center object-contain lg:w-full lg:h-full absolute">
          <Image
            src={trophyImage}
            alt="Trophy Avatar"
            objectFit="contain"
            layout="fill"
            quality={100}
            placeholder="blur"
            blurDataURL={blurDataURL}
          />
        </div>
        <div
          aria-hidden="true"
          className="w-full bg-gradient-to-b from-transparent to-black opacity-100 absolute sm:absolute sm:inset-0"
        ></div>
        <div className="p-6 flex items-end absolute inset-0">
          <div>
            <h3 className="mt-2 mb-1 ml-[10px] font-semibold text-white text-sm">
              {numberOfTimesWon}
            </h3>
            <div className="border-t-2 border-red-600 dark:border-green-800 w-1 pl-8 mb-4"></div>

            <span className="absolute bottom-3 left-[24px] right-[24px] font-semibold text-white text-base truncate">
              {trophyName}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default TrophyDataCard;
